const validate = (values) => {
  const attrs = values || {};
  const errors = {};
  if (!attrs.materia || !attrs.materia.value) {
    errors.materia = 'Debe seleccionar una materia';
  }

  if (!attrs.interventor || !attrs.interventor.value) {
    errors.interventor = 'Debe seleccionar un interventor';
  }

  if (attrs.interventorAuxiliar && attrs.interventorAuxiliar.value === attrs.interventor.value) {
    // errors.interventor = 'Ya seleccionó a este funcionario este como el interventor principal'
  }

  if (!attrs.fecha) {
    errors.fecha = 'Debe ingresar la fecha del examen';
  }

  if (!attrs.fechaLimiteInscripcion) {
    errors.fechaLimiteInscripcion = 'Debe ingresar la fecha límite inscripción';
  }

  if ((attrs.fechaInicioReclamo && !attrs.fechaFinReclamo)
      || (!attrs.fechaInicioReclamo && attrs.fechaFinReclamo)) {
    errors.fechaInicioReclamo = 'Debe completar inicio y fin de solicitud de revisión';
    errors.fechaFinReclamo = 'Debe completar inicio y fin de solicitud de revisión';
  }

  if (attrs.fechaInicioReclamo && attrs.fechaFinReclamo
      && new Date(attrs.fechaInicioReclamo) > new Date(attrs.fechaFinReclamo)) {
    errors.fechaInicioReclamo = 'El inicio de la solicitud de revisión no puede ser mayor al fin';
    errors.fechaFinReclamo = 'El fin de la solicitud de revisión no puede ser menor al inicio';
  }

  if (!attrs.periodo || !attrs.periodo.value) {
    errors.periodo = 'Debe ingresar el periodo';
  }

  if (!attrs.nroActa) {
    errors.nroActa = 'Debe ingresar el número de acta';
  }

  return errors;
};

export default validate;
